import { render, staticRenderFns } from "./RFPViewMine.vue?vue&type=template&id=36664edc&scoped=true"
import script from "./RFPViewMine.vue?vue&type=script&lang=js"
export * from "./RFPViewMine.vue?vue&type=script&lang=js"
import style0 from "./RFPViewMine.vue?vue&type=style&index=0&id=36664edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36664edc",
  null
  
)

export default component.exports